import gql from "graphql-tag";

export const BOOKING_FRAGMENT = gql`
    fragment BookingFragment on Booking{
        error 
        errorCode 
        errorMessage
        meta{
          stops 
          trips 
          nights 
          days 
        }
        iso_currency
        uuid
        reference
        status
        tmsBookingId
        expired
        expiration
        paymentDueDate
        fullPaymentDueDate
        agent
        agency
        items {
          id
          type
          tourId
          name
          date
          price
          pricePerPassenger
          commission
          promoCode
          cityCount
          discount
          nett
          paid
          due
          deposit
          nights
          expiration
          passengers
          tripDetails
          tripPassengers
          onRequest
          fullPaymentDueDate
        }
        itinerary {
          id
          name
          type
          from
          to
          date
          nights
          price
          discount
          endDate
          error
          arrival
          departure
          message
          cityInfo {
            hero
            address
            stacklaTag
            location {
              lon
              lat
            }
            pickUpDropOff {
              lon
              lat
            }
            hostel {
              propertyId
              hostelName
              city
              country
              dormRoom
              dormRoomMax
            }
          }
          productInfo{
            hero
            tourId
            duration
            startDescription
            endDescription
            startCity{
              name
              address
            }
            endCity{
              name
              address
            }
            inclusionList
            accommodation
            webUrl
          }
          accommodation {
            options {
              hostel {
                type
                name
                propertyType
                city
                country
                rooms {
                  type
                  description
                  price
                  total
                  maxRoomCapacity
                  roomCode
                  roomBoard
                }
              }
            }
            reservations {
              id
              name
              date
              nights
              pricePerNight
              total
              currency
              roomType
              type
              propertyType
              isBackstop
              roomCode
              roomBoard
              beds
              rooms
              location{
                lat 
                lon
              }
              address
            }
            nights
          }
          error
          message
        }
        prices {
          accommodation
          accommodationPerPassenger
          trips
          tripsPerPassenger
          total
          totalPerPassenger
          due
          paid
          discount
          nett
          commission
          deposit
          deposit
        }
        passengers {
          id
          first_name
          last_name
          type
          lead
          email
          gender
          date_of_birth
          iso_nationality
          iso_nationality_sate
          telephone_country_code
          telephone_number
          emergency_contact
          emergency_number
          emergency_country_Code
        }
        documents
        payments
        paymentTransactions
    }
`;
